import * as Yup from "yup";
import "./locale";

export default () => (
  Yup.object().shape({
    month_rev: Yup.number().required(),
    month_rev_other: Yup.number().required(),
    variable_rev: Yup.number().required(),
  
}))